import PrivacyPolicy from '../pages/PrivacyPolicy'
import Terms from '../pages/Terms'
import HomeStartUp from '../pages/HomeStartUp'
import NotFound from '../pages/elements/404'

export const routes = [
    {
        path:'/',
        name: 'HomeStartUp',
        component: HomeStartUp
    },
    {
        path:'/privacy-policy',
        name: 'PrivacyPolicy',
        component: PrivacyPolicy
    },
    {
        path:'/terms',
        name: 'Terms',
        component: Terms
    },
    {
        path:'*',
        name: 'NotFound',
        component: NotFound
    },
];